import React from 'react';
import { motion } from 'framer-motion';
import { AGREEXA_APP_URL } from '../lib/links';
import { Users, GitFork, Library, MessageSquare, Plus } from 'lucide-react';
const creators = [{
  name: 'Sarah Woodcraft',
  specialty: 'Fine Woodworking',
  followers: '124k',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=256&auto=format&fit=crop'
}, {
  name: 'Marcus Tech',
  specialty: 'Smart Home & IoT',
  followers: '89k',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=256&auto=format&fit=crop'
}, {
  name: 'Elena Builds',
  specialty: '3D Printing',
  followers: '210k',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=256&auto=format&fit=crop'
}, {
  name: 'David Eco',
  specialty: 'Off-Grid Systems',
  followers: '56k',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=256&auto=format&fit=crop'
}];
const features = [{
  icon: GitFork,
  title: 'Fork & Remix',
  desc: 'Take an existing project, fork the plans, and add your own unique spin.'
}, {
  icon: Library,
  title: 'Build Collections',
  desc: 'Curate boards of inspiration, tools, and projects for your next big build.'
}, {
  icon: MessageSquare,
  title: 'Ask the Community',
  desc: 'Stuck on a step? Get help from thousands of experienced makers instantly.'
}];
export function MakerCommunity() {
  return <section className="py-24 bg-white dark:bg-navy-800 border-t border-gray-100 dark:border-navy-700" data-id="element-178">
      <div className="max-w-7xl mx-auto px-6" data-id="element-179">
        <div className="flex flex-col md:flex-row items-end justify-between mb-16 gap-6" data-id="element-180">
          <div className="max-w-2xl" data-id="element-181">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-forest-100 dark:bg-forest-500/10 text-forest-600 dark:text-forest-400 text-sm font-semibold mb-6" data-id="element-182">
              <Users size={16} data-id="element-183" /> Maker Community
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 dark:text-white mb-4" data-id="element-184">
              Build Together.
            </h2>
            <p className="text-lg text-navy-700 dark:text-gray-400" data-id="element-185">
              Join millions of creators. Share your progress, fork projects, and
              learn from the best makers in the world.
            </p>
          </div>
          <button onClick={() => {
          window.location.href = AGREEXA_APP_URL;
        }} className="px-6 py-3 rounded-full bg-navy-900 dark:bg-white text-white dark:text-navy-900 font-semibold hover:bg-navy-800 dark:hover:bg-gray-100 transition-colors" data-id="element-186">
            Join Community
          </button>
        </div>

        <div className="grid lg:grid-cols-3 gap-12" data-id="element-187">
          {/* Top Creators */}
          <div className="lg:col-span-2" data-id="element-188">
            <h3 className="text-xl font-bold text-navy-900 dark:text-white mb-6" data-id="element-189">
              Top Creators
            </h3>
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-190">
              {creators.map((creator, index) => <motion.div key={creator.name} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center justify-between p-4 rounded-2xl glass-card hover:border-orange-500/50 transition-colors" data-id="element-191">
                  <div className="flex items-center gap-4" data-id="element-192">
                    <img src={creator.image} alt={creator.name} className="w-14 h-14 rounded-full object-cover border-2 border-white dark:border-navy-700" data-id="element-193" />
                    <div data-id="element-194">
                      <h4 className="font-bold text-navy-900 dark:text-white text-sm" data-id="element-195">
                        {creator.name}
                      </h4>
                      <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-196">
                        {creator.specialty}
                      </p>
                      <p className="text-xs font-medium text-orange-500 mt-0.5" data-id="element-197">
                        {creator.followers} followers
                      </p>
                    </div>
                  </div>
                  <button onClick={() => {
                window.location.href = AGREEXA_APP_URL;
              }} className="w-8 h-8 rounded-full bg-navy-100 dark:bg-navy-700 flex items-center justify-center text-navy-900 dark:text-white hover:bg-orange-500 hover:text-white dark:hover:bg-orange-500 transition-colors" data-id="element-198">
                    <Plus size={16} data-id="element-199" />
                  </button>
                </motion.div>)}
            </div>
          </div>

          {/* Features */}
          <div data-id="element-200">
            <h3 className="text-xl font-bold text-navy-900 dark:text-white mb-6" data-id="element-201">
              Community Tools
            </h3>
            <div className="space-y-6" data-id="element-202">
              {features.map((feature, index) => <motion.div key={feature.title} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex gap-4" data-id="element-203">
                  <div className="w-12 h-12 rounded-xl bg-orange-50 dark:bg-orange-500/10 flex-shrink-0 flex items-center justify-center text-orange-500" data-id="element-204">
                    <feature.icon size={24} data-id="element-205" />
                  </div>
                  <div data-id="element-206">
                    <h4 className="font-bold text-navy-900 dark:text-white mb-1" data-id="element-207">
                      {feature.title}
                    </h4>
                    <p className="text-sm text-navy-700 dark:text-gray-400 leading-relaxed" data-id="element-208">
                      {feature.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}